import { Component, Input, OnInit,OnChanges, SimpleChanges, HostListener, } from '@angular/core';
import { Activity, ActivityModel } from 'src/app/models/activities/activity';
import { FeeDataEntity } from 'src/app/models/data-entities/fee-data-entity';

@Component({
  selector: 'app-common-estimate-total-fee',
  standalone: false,
  templateUrl: './common-estimate-total-fee.component.html',
  styleUrl: './common-estimate-total-fee.component.scss'
})
export class CommonEstimateTotalFeeComponent implements OnInit, OnChanges{
  @Input() totalFee = 0;
  @Input() feeDetails: any[] = [];

  showFeeDetails = false;

  toggleDetails(): void {
    this.showFeeDetails = !this.showFeeDetails;
  }
  @HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  if (!this.showFeeDetails) {
    return;
  }

  const target = event.target as HTMLElement;

  // Keep it open if the click happened inside the related applications card
  if (target.closest('.estimated-total-card')) {
    return;
  }

  // Any click outside the card closes it
  this.showFeeDetails = false;
}

@HostListener('window:scroll')
onWindowScroll(): void {
  if (this.showFeeDetails) {
    this.showFeeDetails = false;
  }
}
 @Input() applicationId: string;
  @Input() currentActivity: Activity<ActivityModel>;

  @Input() fees: FeeDataEntity[];
  displayFees: { label: string; value: number }[];

  totalFees: number;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['applicationId'] || changes['currentActivity']) {
      this.loadFees();
    }
  }

  loadFees() {
    this.displayFees = [];

    // total the fees
    let total = 0;

    for (let x = 0; x < this.fees?.length; x++) {
      const f: FeeDataEntity = this.fees[x];

      this.displayFees.push({
        label: f.label,
        value: isNaN(parseFloat(f.formulaValue))
          ? 0
          : parseFloat(f.formulaValue)
      });

      total +=
        parseFloat(f && f.formulaValue && f.formulaValue.toString()) || 0;
    }

    this.totalFees = total;
  }

  ngOnInit() {
    this.loadFees();
  }


}
